import $PRIVILEGES from 'privilege_manager/privileges';

/**
 * Secciones del CMS: el privilegio que da acceso y su página de entrada.
 *
 * El orden decide a dónde llega quien tiene varias: la primera de la lista.
 * Quien no tiene ninguna no puede usar el CMS (ver Middleware). Una sección
 * nueva va aquí además de en urls.js y en el menú (layout.js y navbar.js).
 */
export const PAGES = [
  { privilege: $PRIVILEGES.boe_kb, path: '/lista_de_base_de_conocimientos' },
  { privilege: $PRIVILEGES.standard_kb, path: '/lista_de_base_de_conocimientos' },
  { privilege: $PRIVILEGES.questions, path: '/preguntas' },
  { privilege: $PRIVILEGES.programs, path: '/lista_de_programas_y_prefabs' },
  // Al final: quien ya tenía otra sección sigue entrando donde siempre
  { privilege: $PRIVILEGES.ecommerce, path: '/ecommerce' },
];

/**
 * Página de entrada según los privilegios (las filas del login o de
 * account/getPrivileges), o null si no tiene acceso a ninguna sección.
 */
export const getRootPage = (privileges = []) => {
  const ids = privileges.map(privilege => privilege.privilege_id);
  const page = PAGES.find(page => ids.includes(page.privilege));
  return page ? page.path : null;
}
